var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("v-data-table", {
          staticClass: "elevation-2",
          attrs: {
            headers: _vm.headers,
            items: _vm.attachments,
            page: _vm.pagination.page,
            "items-per-page": _vm.pagination.rowsPerPage,
            "items-per-page-text": _vm.rowsPerPageText,
            "items-per-page-items": _vm.rowsPerPageItems,
            "header-props": { sortIcon: _vm.sortIcon },
            "footer-props": { prevIcon: _vm.prevIcon, nextIcon: _vm.nextIcon }
          },
          on: {
            "update:page": function($event) {
              return _vm.$set(_vm.pagination, "page", $event)
            }
          },
          scopedSlots: _vm._u([
            {
              key: "item",
              fn: function(props) {
                return [
                  _c(
                    "tr",
                    {
                      class: { "cursor-pointer": true },
                      on: {
                        click: function($event) {
                          return _vm.viewItem(props.item)
                        }
                      }
                    },
                    [
                      _c("td", [_vm._v(_vm._s(props.item.name))]),
                      _vm._v(" "),
                      !_vm.commentID
                        ? _c("td", [
                            _vm._v(
                              "\n            " +
                                _vm._s(props.item.objBelongingId) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("app-datatable-action-buttons", {
                            attrs: {
                              "user-can-delete": true,
                              "user-can-edit": false
                            },
                            on: {
                              delete: function($event) {
                                return _vm.askConfirmationToDeleteItem(
                                  props.item
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              }
            },
            {
              key: "pageText",
              fn: function(props) {
                return [
                  _vm._v(
                    "\n        " +
                      _vm._s(props.pageStart) +
                      " - " +
                      _vm._s(props.pageStop) +
                      " " +
                      _vm._s(_vm.$t("tables.Of")) +
                      "\n        " +
                      _vm._s(props.itemsLength) +
                      "\n      "
                  )
                ]
              }
            }
          ])
        }),
        _vm._v(" "),
        _c("app-dialog-box", {
          attrs: {
            open: _vm.deleteDialog,
            title: _vm.$t("DeleteAttachment"),
            content:
              _vm.$t("DeleteConfirmation") + " " + _vm.itemToDelete.name + "?",
            "main-action-label": _vm.$t("No"),
            "secondary-action-label": _vm.$t("Yes"),
            loading: _vm.loadingDelete
          },
          on: {
            mainAction: _vm.cancelDelete,
            secondaryAction: function($event) {
              return _vm.deleteAttachment(_vm.itemToDelete.id)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-097c4e0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-097c4e0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support/TechnicalSupport/AttachmentsTable.vue
// module id = null
// module chunks = 